import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAaCAMAAADhRa4NAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIAAACk9CB/AAAAD3RSTlMAM3dmEaruVbuZRCLdzIhw5sf5AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAALVJREFUKM+dkuEWgyAIRsXITCTe/22HVgtdubPdfx/co1A6dwF+6vFo+m6WT6ZOCA0qLK0wuwb8QcBCHAjHSI8CfBNWkQQ0uCJIHg5JIn4oeBF6FhBdFtEtH4Rkv/ydsFgh3gsLnOC90JX/EzzzZr2N2V8CYa4j4psaM5LZIuT2qeUjn4L+CrZ9di4fAqYEoRSiCKQKVIElaN4H2/QIrtUddVkPWO06BeqyWQtjCExXJs1x778A/0ARZxhahUQAAAAASUVORK5CYII=",
      title: "Fast Delivery",
      description: "Fast Shipping on all order",
      accent: "#4F7E17",
      bg: "#edf5e0",
    },
    {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAMAAABluEcAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIAAACk9CB/AAAAD3RSTlMAEVWImardZiIz7sxEd7t7dQzWAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAOlJREFUKM+tU9sSQxEMjBCXOOX//7YIpSZ96z6Ykc11BcCGQevIWTSgAX1d8OEIisM9sTBZvDgtniu103ajjcMS5XLydBhgutPm+zV+NRM/AY1P7XL3bJrtmXxrKcGNloGFv2ovvGoNi1cF4eon/1J5O7oa/IMdV4/GPSu/IGhZtuoV4T942E9w0XjcJbtEJlyNRztAwptf84cZzyK0OhmL0NpkuOqD8ryjLJPwWJUKTVd009465e8MxvcFoxWXL3V77Qybh9J3ez6gGT+hSN5z2OZCjvx+y4h774zbqnanfrFkS/a52HNZ3/ulDmNUD6OhAAAAAElFTkSuQmCC",
      title: "Return Policy",
      description: "Easy return facility for any problem",
      accent: "#F88702",
      bg: "#fff3e0",
    },
    {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIAAACk9CB/AAAAD3RSTlMAEVWZu8xmIjOq7t2IRHdkThm3AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAOdJREFUKM/NU0kCAyEIc19Qy/9/W9Dp4DLtuTkpQQhRlRJoY513Nmj1hOjxA59OOjMBPnvgRd5YzdEcRyFOhaWJpkiJ0qrQfk6gvVvqOcqXXSVJW0MSW+fqh96pg0VsB59kiKXX3GEsDGJ44AOiuaSuw4goHqp2R8PuaAo9Xmn00lNO+Vg9CQO0if3cePa7WQoD5vbf/Ff9iXmPwK9hv4EeAwqb7lNUO+Lwtd8Dlgf/AaCEYaVTv0DP9XUtDVw/oM6V+EeYSEj3D7lP9LuUMNbGgHUebYUPhNf5njUjSh3zKDUVGLgf5BuqehKwt1Jo/AAAAABJRU5ErkJggg==",
      title: "24/7 Support",
      description: "24 hours live support at your service",
      accent: "#F0C400",
      bg: "#fffbea",
    },
    {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIAAACk9CB/AAAAD3RSTlMAEURmiKq7zN2Z7lUzIncmlTTXAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAS9JREFUKM91k1kCwyAIREVA3ND737Yal8Ym5StxVB4wGjMDLBI78SIc0II5wnKsZ0SXtkprzTsWdn7tpUvN169Dvd2n6K4duX32g8k8I/VzakKtxbxHqZVNrGL+havetEvgjwxNMz3LewLsZJdeI+mPqDSEro96pbUtK2i2GGS3qenBoK/P8Nhq6zp3lBTk2+IoIXVoHvfnDQyqCrucvPjolZ++/JV/JgqWN18ddJ4Jk802NR/MlTr5rHvhd/bGb3LhPfcoXC7myX+bLsCNIy0+9zYh4Bu/lHMAirL5/aQTpoKIhZxffpx8GuIDPwad/M6MAUzjxmZjGu1yTeeD/3Ro91/umfOLqjIMbke2YwBgB1HahY7nE4go8HICryOA8uCXcjYtt7GJb/DtARNuoA/aTxkcrM638AAAAABJRU5ErkJggg==",
      title: "Secure Payment",
      description: "We accept all the payment method",
      accent: "#CD0302",
      bg: "#fff5f5",
    },
  ];

  return (
    <div
      className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] py-8 md:py-12"
      style={{ background: '#fff', borderTop: '2px solid #F5D19D' }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {features.map((feature, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                padding: '20px 28px',
                borderRight: index !== features.length - 1 ? '1px dashed #F5D19D' : 'none',
                transition: 'background 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#FFF8EC'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              {/* Icon container — soft glowing orb, no border */}
              <div
                style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '18px',
                  background: feature.bg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  boxShadow: `0 4px 16px ${feature.accent}22`,
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                {/* Soft accent glow dot */}
                <div style={{
                  position: 'absolute',
                  top: '-8px', right: '-8px',
                  width: '28px', height: '28px',
                  borderRadius: '50%',
                  background: feature.accent,
                  opacity: 0.18,
                }} />
                <img
                  src={feature.icon}
                  alt={feature.title}
                  loading="lazy"
                  style={{
                    width: '28px',
                    height: '28px',
                    objectFit: 'contain',
                    filter: `opacity(0.85) drop-shadow(0 2px 4px ${feature.accent}55)`,
                    position: 'relative',
                    zIndex: 1,
                  }}
                />
              </div>

              {/* Text */}
              <div>
                <h6
                  style={{
                    fontSize: '15px',
                    fontWeight: 800,
                    color: feature.accent,
                    margin: '0 0 4px',
                    letterSpacing: '-0.01em',
                  }}
                >
                  {feature.title}
                </h6>
                <p style={{ fontSize: '12px', color: '#888', margin: 0, lineHeight: 1.5 }}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;